// extracted by mini-css-extract-plugin
module.exports = {"messageWrapper":"SuccessStep_messageWrapper__xdLol","successStepRichText":"SuccessStep_successStepRichText__43DCn","closeButton":"SuccessStep_closeButton__tw4lv"};